module.exports = __webpack_public_path__ + "img/screen-privacy-security.750ee1b5.jpg";